module.exports = __webpack_public_path__ + "img/bluedownarrow.800857a7.svg";